import { authResource } from '@/services/auth.service'
import useDeviceInfo from '@/composables/useDevice'
import useAuthToken from '@/composables/useAuthToken'

export default async function useDeviceAuthentication() {
  const { data: { access, refresh } } = (await authResource.execute({ type: 'device' }, { ...useDeviceInfo() }))
  
  return { access, refresh }
}